/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useEffect, useState, useCallback, useContext,
} from 'react';
import { motion } from 'framer-motion';
import { distributorService } from '../../../service/distributor.service';
import HeaderContext from '../../../Components/Context/HeaderContext';
import Pagination from '../../../Components/Pagination';
import FilterModal from './FilterModal';
import ListSkeleton from './listSkeleton';
import EmptyScreen from '../../../Components/GlobalEmplyPage';

function FGStockDetails() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const [stockdetailsList, setStockDetailsList] = useState([]);
    const [sortType, setsortType] = useState('ITEM_QUANTITY+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [loading, setLoading] = useState(true);
    const [filterModal, setFilterModal] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [emptyData, setEmptyData] = useState(false);
    const [threeplList, setThreeplList] = useState([]);
    const [mainCategory, setMainCategory] = useState([]);
    const [Filter, setFilter] = useState({
        item_code: [],
        plant_name: [],
        product_categories: [],
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    const handleFetchMainCategories = async () => {
        const category = await distributorService.getOffersMainCategory();
        if (category.data.data.length > 0) {
            setMainCategory(category.data.data);
        }
    };

    const handleFetchthreepl = async () => {
        const data = await distributorService.shippingOrganizationLocationsForFilter();
        if (data.data.success_status === true) {
            setThreeplList(data.data.Items);
        }
    };

    const handleFetchFGStockDetails = useCallback((() => {
        distributorService.MISFGStockReports(currentPage, sortType, searchValue, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.data.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setStockDetailsList(response.data.data);
                setCurrentPage(response.data.current_page);
                setTotalPage(response.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue]);

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    const handleExport = useCallback((() => {
        distributorService.MISFGStockReports(currentPage, sortType, searchValue, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleFetchFGStockDetails();
        handleFetchthreepl();
        handleFetchMainCategories();
    }, [handleFetchFGStockDetails]);

    return (
        <div className="py-6 pr-[18px] main-screen">
            <div className="flex justify-between pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">FG Stock Details/ Warehouse wise Report</h5>
                <div className="flex">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{
                            border: '2px solid #E9EDF4',
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setFilterModal(true)}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px] pr-[15px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                                setCurrentPage(1);
                            }}
                            autoComplete="off"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => setexportClick(!exportClick)}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu min-w-[100px] ${exportClick === true ? 'show' : 'hidden'} absolute  bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('pdf-converter')}
                                >
                                    PDF

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <ListSkeleton />
                : (
                    <div>
                        { stockdetailsList.length > 0 && (
                            <div className="overflow-auto dropdown-menu pb-7 relative z-10" style={{ height: 'calc(100vh - 298px)' }}>
                                <table className="w-full table-auto relative">
                                    <thead className="top-0 left-0 sticky z-[2]">
                                        <tr className="bg-[#555259] h-10">
                                            <th className="py-[5px] px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Warehouse/3PL
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[168px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Main Categories
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Product Categories
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px] text-center flex justify-center items-center pt-4">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Product Main Group
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Product Sub Group
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[160px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Item Code
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Item Description
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[188px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Item Quantity
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{ rotate: sortType === 'ITEM_QUANTITY+asc' ? 180 : 0 }}
                                                            className={`${sortType === 'ITEM_QUANTITY+desc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (sortType === 'ITEM_QUANTITY+asc') {
                                                                    setsortType('ITEM_QUANTITY+desc');
                                                                } else if (sortType === 'ITEM_QUANTITY+desc') {
                                                                    setsortType('ITEM_QUANTITY+asc');
                                                                } else {
                                                                    setsortType('ITEM_QUANTITY+asc');
                                                                }
                                                                // setCurrentPage(1);
                                                                // setisLoaded(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    UOM
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[230px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Product Classification
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[230px] rounded-br-lg rounded-tr-lg">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    AWS Classification
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stockdetailsList.length > 0 && stockdetailsList.map((item) => (
                                            <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                                <td
                                                    className="text-sm font-normal text-[#090406] py-[5px] px-7 sticky left-0 flex justify-center items-center pt-4"
                                                    style={{
                                                        background: 'rgba(255, 255, 255, 0.45)',
                                                        backdropFilter: 'blur(5.5px)',
                                                    }}
                                                >
                                                    {item?.WAREHOUSE_3PL_NAME}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.MAIN_CATEGORY}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] text-center py-[5px] px-7">
                                                    {item?.PRODUCT_CATEGORY}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.PRODUCT_MAIN_GROUP}
                                                </td>
                                                {item?.PRODUCT_SUB_GROUP === null
                                                    ? (
                                                        <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                            -
                                                        </td>
                                                    )

                                                    : (
                                                        <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                            {item?.PRODUCT_SUB_GROUP}
                                                        </td>
                                                    )}
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.CONCATENATED_SEGMENTS}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] more-lines px-7 text-center">
                                                    {item?.DESCRIPTION}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.ITEM_QUANTITY}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {item?.UOM}
                                                </td>
                                                {item?.PRODUCT_CLASSIFICATION === null
                                                    ? (
                                                        <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                            -
                                                        </td>
                                                    )

                                                    : (
                                                        <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                            {item?.PRODUCT_CLASSIFICATION}
                                                        </td>
                                                    )}

                                                {item?.AWS_CLASSIFICATION === null
                                                    ? (
                                                        <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                            -
                                                        </td>
                                                    )

                                                    : (
                                                        <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                            {item?.AWS_CLASSIFICATION}
                                                        </td>
                                                    )}

                                            </tr>

                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        ) }
                        {stockdetailsList.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                List={stockdetailsList}
                                currentPage={currentPage}
                                totalPage={totalPage}
                            />
                        )}
                        {filterModal && (
                            <FilterModal
                                filterModal={filterModal}
                                setFilterModal={setFilterModal}
                                threeplList={threeplList}
                                setThreeplList={setThreeplList}
                                mainCategory={mainCategory}
                                setMainCategory={setMainCategory}
                                stockdetailsList={stockdetailsList}
                                setStockDetailsList={setStockDetailsList}
                                Filter={Filter}
                                setFilter={setFilter}
                                handleFilter={handleFilter}
                                filterValue={filterValue}
                                setfilterValue={setfilterValue}
                                handleFetchFGStockDetails={handleFetchFGStockDetails}
                            />
                        )}
                    </div>
                )}

            {emptyData && (
                <EmptyScreen
                    searchValue={searchValue}
                    text="no FG Stock Details/ Warehouse wise Report"
                    buttonRequired={false}
                />
            )}

        </div>
    );
}

export default FGStockDetails;
